import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DesignSystemComponent } from './modules/design-system/design-system.component';

const routes: Routes = [
  { path: "", redirectTo: "accounts", pathMatch: "full" },
  { path: 'quotations', loadChildren: () => import('./modules/quoting-tool/quoting-tool.module').then((m) => m.QuotingToolModule) },
  { path: "accounts", loadChildren: () => import("./modules/auth/auth.module").then((m) => m.AuthModule) },
  { path: 'customer',data: { breadcrumb: 'Home' }, loadChildren: () => import('./shared/layout/layout.module').then(m => m.LayoutModule)},
  { path: 'quotation-proposal', loadChildren: () => import('./modules/quotation-proposal/quotation-proposal.module').then(m => m.QuotationProposalModule)},
  { path: "design-system",component: DesignSystemComponent},
  {
    path: 'user-manual',
    loadComponent: () => import('./modules/user-manual/user-manual.component').then(m => m.UserManualComponent)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
